/* eslint-disable no-undef */
<template>
  <div id="app">
    <transition
      :name="pageTransitionName"
      @before-enter="handleBeforeEnter"
      @after-enter="handleAfterEnter"
    >
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view class="app-wrapper"></router-view>
      </keep-alive>
      <router-view v-else class="app-wrapper"></router-view>
    </transition>
  </div>
</template>
<script>
import { checkBrowser } from '@/plugin/checkBrowser/checkBrowser.js'
import doWxConfig from '@/plugin/wxConfig'
export default {
  data () {
    return {
      show: true
    }
  },
  computed: {
    pageTransitionName () {
      if (this.$store) {
        return this.$store.state.appShell.pageTransitionName
      }
      return ''
    }
  },
  created () {
    if (checkBrowser() === 'WECHAT') {
      doWxConfig()
    }
  },
  methods: {
    setPageSwitching (val) {
      return this.$store
        ? this.$store.dispatch('appShell/setPageSwitching', val)
        : () => { console.log('please open vuex first') }
    },
    handleBeforeEnter () {
      this.setPageSwitching(true)
    },
    handleAfterEnter () {
      this.setPageSwitching(false)
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  height: 100%;

  .app-wrapper {
    box-sizing: border-box;
    transition: transform 0.3s cubic-bezier(0.55, 0, 0.1, 1);

    &.slide-left-enter-active {
      transform: translate3d(100%, 0, 0);
    }

    &.slide-right-enter-active {
      transform: translate3d(-100%, 0, 0);
    }
  }
}
</style>

<style lang="scss">
@import './assets/css/reset.scss';
</style>
